<template>
    <svg width="81" height="81" viewBox="0 0 81 81" xmlns="http://www.w3.org/2000/svg">
        <path d="M40.5 0C62.868 0 81 18.132 81 40.5S62.868 81 40.5 81 0 62.868 0 40.5 18.132 0 40.5 0zm.188 29c-.592 0-1.088.192-1.488.576a1.926 1.926 0 0 0-.593 1.29l-.007.198v8.208h-7.752c-.462 0-.857.126-1.184.377l-.136.115c-.352.328-.528.748-.528 1.26 0 .528.176.968.528 1.32.313.313.695.487 1.147.521l.173.007H38.6v7.992c0 .526.155.97.465 1.332l.123.132c.392.384.884.576 1.476.576.608 0 1.104-.192 1.488-.576.341-.341.531-.771.569-1.29l.007-.198v-7.968h7.824c.462 0 .857-.132 1.184-.395l.136-.121c.352-.344.528-.764.528-1.26 0-.528-.176-.964-.528-1.308a1.777 1.777 0 0 0-1.126-.508l-.194-.008h-7.824V31.04c0-.526-.145-.97-.436-1.332l-.116-.132c-.368-.384-.864-.576-1.488-.576z" fill="#168171" fill-rule="evenodd"/>
    </svg>
</template>

<script>
export default {
    name: 'IconAdd',
};
</script>
